import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { setFundChartTitle } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/title/title.actions';
export const title = createReducer('', on(setChartData, (state, { chartData }) => chartData.params.title), on(setFundChartTitle, (state, action) => action.title));
